import { DateTime } from 'luxon'
import { BillingCategoryCode } from './Receipt'

type BuildingData = {
  id: number
  name: string
  standardMeterReadingDay: number
  postalCode: string
  address: string
  isDormitory: boolean
}

type RoomData = {
  id: number
  name: string
}

type BillingCategory = {
  id: number
  code: BillingCategoryCode
  name: string
}

export const BillingType = {
  Room: 0, // 入居先
  SeparateDelivery: 1, // 別送先
  NewAddress: 2, // 転居先
} as const
export type BillingType = (typeof BillingType)[keyof typeof BillingType]

export const billingTypeText = (biType: BillingType) => {
  switch (biType) {
    case BillingType.Room:
      return '入居先'
    case BillingType.SeparateDelivery:
      return '別送先'
    case BillingType.NewAddress:
      return '転居先'
  }
}

export type TenantData = {
  id: number
  moveInOn: string
  moveOutOn: string | null
  payerFirstName: string | null
  payerLastName: string | null
  payerFirstNameKana: string | null
  payerLastNameKana: string | null
  emergencyContactFirstName: string | null
  emergencyContactLastName: string | null
  emergencyContactFirstNameKana: string | null
  emergencyContactLastNameKana: string | null
  emergencyContactRelationship: string | null
  consumptionAlertThreshold: number

  billingCategory: BillingCategory

  room: RoomData & {
    building: BuildingData
  }
}

export default class Tenant {
  declare id: number
  declare moveInOn: DateTime
  declare moveOutOn: DateTime | null
  declare payerFirstName: string | null
  declare payerLastName: string | null
  declare payerFirstNameKana: string | null
  declare payerLastNameKana: string | null
  declare emergencyContactFirstName: string | null
  declare emergencyContactLastName: string | null
  declare emergencyContactFirstNameKana: string | null
  declare emergencyContactLastNameKana: string | null
  declare emergencyContactRelationship: string | null
  declare consumptionAlertThreshold: number

  declare billingCategory: BillingCategory

  declare room: RoomData & {
    building: BuildingData
  }

  // Computed properties ------------------------------------------------------

  get payerName() {
    if (!this.payerFirstName) return this.payerLastName
    return `${this.payerLastName} ${this.payerFirstName}`
  }

  get payerKana() {
    if (!this.payerFirstNameKana) return this.payerLastNameKana
    return `${this.payerLastNameKana} ${this.payerFirstNameKana}`
  }

  get hasPayerInfo() {
    return !!this.payerName && !!this.payerKana
  }

  // Constructor --------------------------------------------------------------

  constructor(params: TenantData) {
    Object.assign(this, params)
    this.moveInOn = DateTime.fromISO(params.moveInOn)
    this.moveOutOn = params.moveOutOn ? DateTime.fromISO(params.moveOutOn) : null
  }
}
